import { render, staticRenderFns } from "./EdMarkEditor.vue?vue&type=template&id=3b8a4c4b&scoped=true&"
import script from "./EdMarkEditor.vue?vue&type=script&lang=js&"
export * from "./EdMarkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a4c4b",
  null
  
)

export default component.exports